module.exports = __webpack_public_path__ + "img/05.400f61ce.png";